import { UuidSchema } from "@mind/contracts/browser";

export type DocumentsSearch = {
  readonly workspace?: string;
  readonly document?: string;
};

const DOCUMENT_SEARCH_KEYS: Readonly<Record<string, true>> = {
  workspace: true,
  document: true,
};

export function validateDocumentsSearch(input: unknown): DocumentsSearch {
  if (input === null || typeof input !== "object" || Array.isArray(input)) {
    throw new TypeError("Documents route search must be an object");
  }
  const search = input as Readonly<Record<string, unknown>>;
  const unexpectedKey = Object.keys(search).find((key) => DOCUMENT_SEARCH_KEYS[key] !== true);
  if (unexpectedKey !== undefined) throw new TypeError(`Unexpected Documents route search key: ${unexpectedKey}`);
  const workspace = parseOptionalUuid(search["workspace"], "workspace");
  const document = parseOptionalUuid(search["document"], "document");
  return {
    ...(workspace === undefined ? {} : { workspace }),
    ...(document === undefined ? {} : { document }),
  };
}

export function withDocument(current: DocumentsSearch, document: string | null): DocumentsSearch {
  return validateDocumentsSearch({ ...current, document: document ?? undefined });
}

function parseOptionalUuid(value: unknown, key: string): string | undefined {
  if (value === undefined) return undefined;
  const parsed = UuidSchema.safeParse(value);
  if (!parsed.success) throw new TypeError(`Invalid Documents ${key}`);
  return parsed.data;
}
